<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSubmit()">
    <v-container fluid>
      <v-row>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-select
            v-model="solicitacao.area"
            :rules="[rules.required]"
            :items="solicitacaoAreas"
            item-text="nome"
            :item-value="selectArea"
            label="Área *"
            placeholder="Selecione uma área da solicitação"
            filled
            dense
            rounded
            @change="validFields($event)"
          ></v-select>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-select
            v-model="solicitacao.tipoSolicitacao"
            :rules="[rules.required]"
            :items="solicitacaoTipos"
            item-text="nome"
            :item-value="selectTipo"
            label="Tipo *"
            placeholder="Selecione um tipo da solicitação"
            filled
            dense
            rounded
          ></v-select>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-select
            v-model="solicitacao.formaContatoDesejada"
            :rules="[rules.required]"
            :items="solicitacaoContacts"
            item-text="nome"
            item-value="id"
            label="Forma de Contato *"
            placeholder="Selecione uma forma de contato"
            filled
            dense
            rounded
          ></v-select>
        </v-col>
        <v-col :md="2">
          <v-btn
            outlined
            block
            large
            color="primary"
            type="button"
            @click="backStepper()"
          >
            <v-icon>keyboard_arrow_left</v-icon>Voltar
          </v-btn>
        </v-col>
        <v-col :md="2" :offset-md="8">
          <v-btn depressed block large color="primary" type="submit">
            Próximo
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import SolicitacaoService from "@/services/solicitacao.service";

import SolicitacaoModule from "@/store/modules/solicitacao";

export default {
  data() {
    return {
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      },
      solicitacaoAreas: null,
      solicitacaoTipos: null,
      solicitacaoContacts: null
    };
  },
  mounted() {
    this.getSolicitaoAreas();
    this.getSolicitaoTipos();
    this.getSolicitaoFormaContato();
  },
  methods: {
    selectArea(event) {
      return { id: event.id, nome: event.nome };
    },
    selectTipo(event) {
      return { id: event.id, nome: event.nome };
    },
    getSolicitaoAreas() {
      SolicitacaoService.solicitacaoAreas().subscribe(res => {
        this.solicitacaoAreas = res;
      });
    },
    getSolicitaoTipos() {
      SolicitacaoService.solicitacaoTipos().subscribe(res => {
        this.solicitacaoTipos = res;
      });
    },
    getSolicitaoFormaContato() {
      SolicitacaoService.solicitacaoFormasContato().subscribe(res => {
        this.solicitacaoContacts = res;
      });
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        SolicitacaoModule.setstepperTwoValid(isValid);
        this.nextStep(2);
        this.$vuetify.goTo(0);
      }
    },
    nextStep(n) {
      if (n === this.steps) {
        SolicitacaoModule.setCurrentStep(1);
      } else {
        SolicitacaoModule.setCurrentStep(n + 1);
      }
    },
    backStepper() {
      SolicitacaoModule.setCurrentStep(1);
      this.$vuetify.goTo(0);
    },
    validFields(event) {
      if (event.id === 3) {
        this.solicitacao.unidadeConsumidoraNumero = null;
        this.solicitacao.entrouEmContato = false;
      } else {
        this.solicitacao.viagemHoraDeInicio = null;
        this.solicitacao.viagemLocalDeInicio = null;
        this.solicitacao.viagemLocalDeFim = null;
        this.solicitacao.viagemNomeDaLinha = null;
      }
    }
  },
  computed: {
    solicitacao: {
      get: () => SolicitacaoModule.solicitacao,
      set: value => SolicitacaoModule.setSolicitacao(value)
    }
  }
};
</script>

<style></style>
